import React from 'react';
import {FieldErrorsImpl, UseFormRegister} from 'react-hook-form';
import {ITargetGroups} from '../interfaces/ITargetGroups';
import {useTranslation} from 'react-i18next';
import {Col, FormGroup, Row} from 'reactstrap';

interface ITargetGroupsFormProps {
  errors: Partial<
    FieldErrorsImpl<{
      name: string;
      description: string;
    }>
  >;
  register: UseFormRegister<ITargetGroups>;
}

const TargetGroupsForm = ({errors, register}: ITargetGroupsFormProps) => {
  const {t} = useTranslation();
  return (
    <Row>
      <Col md={6}>
        <FormGroup>
          <label className="form-label" htmlFor="name">
            {t('general.name')}
          </label>
          <div className="form-control-wrap">
            <input
              type="text"
              id="reg-type"
              placeholder="Enter your target groups name"
              {...register('name')}
              className="form-control-lg form-control"
            />
            {errors?.name && <p className="invalid">{errors?.name?.message}</p>}
          </div>
        </FormGroup>

        <FormGroup>
          <div className="form-label">{t('general.default')}</div>
          <div className="custom-control custom-switch ">
            <input type="checkbox" className="custom-control-input" id="default" {...register('default')} />
            <label className="custom-control-label form-label" htmlFor="default"></label>
          </div>
        </FormGroup>
      </Col>
      <Col md={6}>
        <FormGroup>
          <label className="form-label" htmlFor="description">
            {t('general.description')}
          </label>
          <div className="form-control-wrap">
            <textarea placeholder={t('general.description') ?? ''} {...register('description')} className="form-control-lg form-control" />
            {errors?.description && <p className="invalid">{errors?.description?.message}</p>}
          </div>
        </FormGroup>
      </Col>
    </Row>
  );
};

export default TargetGroupsForm;
